// ** Navigation imports
import apps from './apps'
import { store } from "../../redux/store"
import {
    Mail,
    Home,
    Map,
    Book,
    BarChart2,
    Circle,
    Sliders,
    Plus,
    PieChart,
    Disc,
    Tag
} from "react-feather"

import ManageRoutes from "../vertical/apps"
import themeConfig from '../../configs/themeConfig'
import { useSelector } from 'react-redux'
import ManageServices from '../../utility/api/services/ManageServices'


const Routes = [
    ...ManageRoutes
]
const accessState = store.getState().accessPage.access


const iconList = {

    "Views": <Home />,
    "Home": <Home />,
    "GM Dashboard": <Sliders />,
    "Manage": <Sliders />,
    "Intel": <BarChart2 />,
    "Reports": <Book />,
    "Report Section": <Book />,
    "Executions": <Sliders />,
    "Invoices": <Tag />


}




export const getAllowedIds = (role, extras = {}) => {
    const { can_use_spam, brandapplied, influencer, tenk_approval } = extras

    let admin = [0, 2, 4, 6, 10, 12, 13, 17, 18, 19, 24, 27, 28, 33, 34, 35, 36, 37, 38, 39];
    let artist = [0, 7, 1, 2, 34, 35];
    let tiktoker = [0, 7, 25, 26, 32];
    let brand = [0, 7, 11, 2, 8, 9, 29, 30, 31, 36, 37];
    console.log(role, 'roooooooooole')
    let ids = [];

    if (role === 'artist' || role === 'musician') {
        ids = [...artist];
    } else if (role === 'tiktoker') {
        let currentTiktoker = [...tiktoker];
        if (can_use_spam && can_use_spam === 'Yes') {
            currentTiktoker.push(22)
        }
        if (brandapplied && brandapplied === 1) {
            currentTiktoker.push(26)
        }
        if (influencer && influencer === 'Yes') {
            currentTiktoker.push(15)
        }
        if (tenk_approval && tenk_approval === 'Yes') {
            currentTiktoker.push(33)
        }
        ids = currentTiktoker;
    } else if (role === 'brand') {
        ids = [...brand];
    } else if (role === 'admin') {
        ids = [...admin];
    } else {
        ids = [0];
    }

    return ids;
}

export const getNavigation = async (role, applybrand, influencer, can_use_spam, tenk_approval) => {

    const navigation = localStorage.getItem('navigation')
    const accountType = localStorage.getItem('accountType')
    let brandapplied = 0;

    let userLocal = localStorage.getItem('userData')
    // if (userLocal) {
    //     userLocal = JSON.parse(userLocal);
    //     if (!can_use_spam) {
    //         if (userLocal && userLocal.can_use_spam && userLocal.can_use_spam == 'Yes') {
    //             can_use_spam = userLocal.can_use_spam;
    //         }
    //     }
    //     if (!tenk_approval) {
    //         if (userLocal && userLocal.tenk_approval && userLocal.tenk_approval == 'Yes') {
    //             tenk_approval = userLocal.tenk_approval;
    //         }
    //     }
    //     if (userLocal && userLocal.brand_applied && (userLocal.brand_applied == '1' || userLocal.brand_applied == 'Yes')) {
    //         brandapplied = 1;
    //     }
    // }

    const allowedIds = getAllowedIds(role, { can_use_spam, brandapplied, influencer, tenk_approval });

    let nav = [];
    allowedIds.map(n => {
        let row = apps.find(x => x.id == n);
        if (row) {
            nav.push(row);
        }
    })

    return nav
}

export const refreshNavigation = async (dispatch) => {
    try {
        const response = await ManageServices.getUserInfo()
        if (response.data && response.data.status) {
            const { user } = response.data
            console.log(user);
            const filteredNavigation = await getNavigation(
                user.user_type,
                user.brand_applied,
                user.influencer,
                user.can_use_spam,
                user.tenk_approval
            )
            dispatch({ type: 'CHANGE_ACCESS', payload: filteredNavigation })
            return filteredNavigation
        }
    } catch (error) {
        console.error("Error refreshing navigation:", error)
    }
}

export default [...apps]
